<!-- Wrapper class scopes every rule in the stylesheet. This component is ViewEncapsulation.None -
     the only way to reach the dropdown panel, which ng-select appends to <body>, outside the
     component's own DOM - so unscoped .modal-title / .form-group rules would leak onto every
     other modal on the site. -->
<div class="ai-chat-feedback-modal">
  <h4 class="modal-title" id="ai-chat-feedback-title">Tell us what went wrong</h4>
  <p class="modal-dec">Your note goes to the GatherCo team with the question and Pebbl's reply, so we
    can see what happened.</p>

  <form [formGroup]="feedbackForm" (ngSubmit)="submit()">
    <div class="form-group">
      <label class="label" for="ai-chat-feedback-category">What was the problem? <span class="req">*</span></label>
      <!-- ai-chat-feedback-select is copied onto the appended panel by ng-select, so it is what
           the panel rules hook onto. -->
      <ng-select class="custom-ng-select-border ai-chat-feedback-select"
        labelForId="ai-chat-feedback-category" [items]="categories" bindLabel="name" bindValue="id"
        [clearable]="false" [appendTo]="'body'" placeholder="Select a reason"
        notFoundText="No reason found" formControlName="category"
        [class.is-invalid]="feedbackForm.controls['category'].invalid && (feedbackForm.controls['category'].touched || isSubmitted)">
      </ng-select>
      @if (feedbackForm.controls['category'].invalid && (feedbackForm.controls['category'].touched ||
      isSubmitted)) {
      <span class="required-message"><span>Please select a reason</span></span>
      }
    </div>

    <div class="form-group">
      <label class="label" for="ai-chat-feedback-note">What happened? <span class="req">*</span></label>
      <textarea class="form-control" id="ai-chat-feedback-note" rows="4" formControlName="note"
        [maxlength]="maxNoteLength" placeholder="Enter what was wrong with this reply"
        [class.is-invalid]="feedbackForm.controls['note'].invalid && (feedbackForm.controls['note'].touched || isSubmitted)"></textarea>
      @if (feedbackForm.controls['note'].invalid && (feedbackForm.controls['note'].touched ||
      isSubmitted)) {
      <span class="required-message"><span>Please tell us what went wrong</span></span>
      }
    </div>

    <div class="secondary-button-inner">
      <button class="btn btn-secondary" type="button" (click)="activeModal.dismiss()">
        <span class="btn-secondary-hover"></span>
        <span class="btn-content">Cancel</span>
      </button>
      <button class="btn btn-primary" type="submit">
        <span class="btn-primary-hover"></span>
        <span class="btn-content">Send Feedback</span>
      </button>
    </div>
  </form>
</div>
